import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import TableReport from '../tableReport/TableReport'
import {
  downloadOverallDisbursement,
  searchOverallDisbursement,
} from '../../../redux/actions/adminReport'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import OverallDisbursementReportForm from './OverallDisbursementReportForm'

export default function OverallDisbursementReportWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isSucceed, setIsSucceed] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [disabledValue, setDisableValue] = useState({})
  const [dataTable, setDataTable] = useState()
  const [loading, setloading] = useState(false)
  const [errorMsg, setErrorMsg] = useState()
  const [condition, setCondition] = useState()
  const [pagSize, setPagSize] = useState(25)
  const [clearValue, setClearValue] = useState(false)

  useEffect(() => {
    //setDataTable(mockCallData)
  }, [])

  const onSubmit = (data) => {
    console.log('onSubmit2 ==>', data)

    let request = {
      projectCode: data.projectCode,
      departmentCode: data.projectDepartment,
      status: data.projectStatusOption || [],
      projectStartDate: data.projectStartDate || null,
      projectEndDate: data.projectEndDate || null,
      fromBudgetYear: data.budgetYearStart || null,
      toBudgetYear: data.budgetYearEnd || null,
      pageNumber: 1,
      pageSize: pagSize,
    }

    console.log('request ==> ', request)
    setCondition(data)
    handlePreviewReport(request)
  }

  const handleSubmitOnPrint = (data) => {
    console.log('handleSubmitOnPrint ', data)

    let request = {
      projectCode: data.projectCode,
      departmentCode: data.projectDepartment,
      projectStartDate: data.projectStartDate || null,
      projectEndDate: data.projectEndDate || null,
      fromBudgetYear: data.budgetYearStart || null,
      toBudgetYear: data.budgetYearEnd || null,
      status: data.projectStatusOption || [],
    }

    setCondition(data)
    handleDownloadReport(request)
  }

  const handelGetSchemaOnReload = async (pagesize, pagenumber) => {
    console.log('handelGetSchemaOnReload ', condition, pagesize, pagenumber)

    let request = {
      projectCode: condition.projectCode,
      departmentCode: condition.projectDepartment || '',
      status: condition.projectStatusOption || [],
      projectStartDate: condition.projectStartDate || null,
      projectEndDate: condition.projectEndDate || null,
      fromBudgetYear: condition.budgetYearStart || null,
      toBudgetYear: condition.budgetYearEnd || null,
      pageNumber: pagenumber,
      pageSize: pagesize,
    }

    setPagSize(pagesize)
    handlePreviewReport(request)
  }

  const handlePreviewReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await searchOverallDisbursement(request)
      console.log('response', response.model)

      if (response.model) {
        const arrLength = response.model.tableColumns.length
        if (response.model.tableColumns[arrLength - 1].dataKey === 'rowNumber') {
          response.model.tableColumns.reverse()
        }

        setDataTable(response.model)
        // setDataTable(mockSchemaTable.model)
      } else {
        handelSetErrorMsg('error', 'ไม่สามารถแสดงข้อมูลได้')
      }
    } catch (e) {
      setIsError(true)
      handelSetErrorMsg('error', e.response.data.errors?.message || 'ไม่สามารถแสดงข้อมูลได้')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDownloadReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await downloadOverallDisbursement(request)

      if (file) {
        downloadFile(file, file.name || `รายงาน${formSchema.reportName}`)
      } else {
        handelSetErrorMsg('error')
      }
    } catch (e) {
      let errorJson = JSON.parse(await e.response.data.text())
      setIsError(true)
      handelSetErrorMsg('error', errorJson?.errors?.message)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    let desc = description ? description : `ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ`
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  const setValueNullField = () => {
    for (const key in getValues()) {
      setValue(key, null)
    }

    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema && (
          <>
            <OverallDisbursementReportForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              // handelPreview={onSubmit}
              clearValue={clearValue}
            />

            <hr />

            {errorMsg && (
              <Message
                showIcon
                type={errorMsg.type}
                description={errorMsg.description}
                style={{ marginBottom: 20 }}
              />
            )}

            <ButtonPanelWidget
              isEdit={true}
              isError={isError}
              buttonText={formSchema.buttonText}
              onPreview={handleSubmit(onSubmit)}
              onPrint={handleSubmit(handleSubmitOnPrint)}
              onCancel={(el) => {
                setDataTable(null)
                setValueNullField()
                // setIsError(false)
                // location.reload()
              }}
            />
          </>
        )}
      </Panel>

      {isLoading && !isError && <OverlayLoader />}

      {dataTable && (
        <>
          <TableReport
            schema={dataTable}
            Controller={Controller}
            control={control}
            pagination={true}
            loading={isLoading}
            onReload={handelGetSchemaOnReload}
          />
          <br />
        </>
      )}
    </>
  )
}

// const mockSchemaTable = {
//   affectedRows: 0,
//   message: 'successfully retrieve data from the database => affected 0 rows',
//   didError: false,
//   errorMessage: null,
//   model: {
//     header: 'ตัวอย่างก่อนพิมพ์ ภาพรวมการเบิกจ่าย และเงินเหลือคืนของเงินอุดหนุนโครงการ',
//     subHeader: 'ภาพรวมการเบิกจ่าย และเงินเหลือคืนของเงินอุดหนุนโครงการ',
//     totalSize: 0,
//     displayLength: 25,
//     buttonText: null,
//     viewSize: [
//       {
//         label: 5,
//         value: 5,
//       },
//       {
//         label: 10,
//         value: 10,
//       },
//       {
//         label: 15,
//         value: 15,
//       },
//       {
//         label: 20,
//         value: 20,
//       },
//       {
//         label: 25,
//         value: 25,
//       },
//     ],
//     tableColumns: [
//       {
//         dataKey: 'rowNumber',
//         label: 'ลำดับ',
//         width: 80,
//         resizable: true,
//         align: 'center',
//       },
//       {
//         dataKey: 'budgetYear',
//         label: 'ปีงบอนุมัติ',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'projectNumber',
//         label: 'เลขที่โครงการ',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'projectCode',
//         label: 'รหัสโครงการ',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'projectName',
//         label: 'ชื่อโครงการ',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'department',
//         label: 'สำนัก',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'coordinatorName',
//         label: 'ผู้ประสานงาน (สสส.)',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'receiveFundedOnBehalf',
//         label: 'รับทุนในนาม',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'organizationName',
//         label: 'องค์กรรับทุน',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'responsibleName',
//         label: 'ผู้รับผิดชอบโครงการ',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'fromDate',
//         label: 'วันเริ่มต้น',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'toDate',
//         label: 'วันสิ้นสุด',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'budgetApprovalAmount',
//         label: 'วงเงินอนุมัติ',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'projectStatus',
//         label: 'สถานะโครงการ',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'periodTotal',
//         label: 'งวดทั้งหมดของโครงการ',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'eFinSubStatus',
//         label: 'สถานะย่อยของ new e-fin',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'dateChangedSubStatus',
//         label: 'วันที่เปลี่ยนสถานะย่อย',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'currentPeriodData',
//         label: 'งวดที่ ณ ปัจจุบันที่ดึงข้อมูล',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'totalIncome',
//         label: 'รายรับรวม',
//         width: 180,
//         resizable: true,
//         align: 'right',
//       },
//       {
//         dataKey: 'interestIncome',
//         label: 'รายได้ดอกเบี้ย',
//         width: 180,
//         resizable: true,
//         align: 'right',
//       },
//       {
//         dataKey: 'expenses',
//         label: 'รายจ่าย',
//         width: 180,
//         resizable: true,
//         align: 'right',
//       },
//       {
//         dataKey: 'unpaidExpenses',
//         label: 'ค่าใช้จ่ายค้างจ่าย',
//         width: 180,
//         resizable: true,
//         align: 'right',
//       },
//       {
//         dataKey: 'amountOfBalanceIncomeAndExpense',
//         label: 'เงินคงเหลือ',
//         width: 180,
//         resizable: true,
//         align: 'right',
//       },
//       {
//         dataKey: 'amountReturned',
//         label: 'จำนวนเงินนำฝากคืน สสส.',
//         width: 180,
//         resizable: true,
//         align: 'right',
//       },
//       {
//         dataKey: 'dateAmountReturned',
//         label: 'วันที่นำฝาก/โอนคืน',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//       {
//         dataKey: 'amountOfBalanceOrganization',
//         label: 'เงินคงเหลือ',
//         width: 180,
//         resizable: true,
//         align: 'right',
//       },
//       {
//         dataKey: 'note',
//         label: 'หมายเหตุ',
//         width: 180,
//         resizable: true,
//         align: 'left',
//       },
//     ],
//     values: [],
//   },
// }
